// extracted by mini-css-extract-plugin
module.exports = {"dropzoneWrapper":"ImageDropzone_dropzoneWrapper__yeXr1","preview":"ImageDropzone_preview__2D2WJ","dropImageText":"ImageDropzone_dropImageText__1I83E"};